import { evalDistroConditional } from './eval';
import { PortalTimelineStep, PortalTimelineStepState } from './survey';

export type PortalTimelineVariant = PortalTimelineStepState['variant'];

/**
 * Resolves the active state for a timeline step against an applicant's info: the
 * first state whose condition matches wins. Returns undefined when no state
 * matches (or the step has no states) — callers fall back to the 'not_started'
 * variant and the step's default content.
 */
export function resolvePortalTimelineStepState(
  step: Pick<PortalTimelineStep, 'states'>,
  info: Record<string, string | undefined>,
): PortalTimelineStepState | undefined {
  return (step.states ?? []).find((state) =>
    evalDistroConditional(state.conditionalOn, info),
  );
}
